import { render, staticRenderFns } from "./WholeSales.vue?vue&type=template&id=91124b0a&scoped=true&"
import script from "./WholeSales.vue?vue&type=script&lang=js&"
export * from "./WholeSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91124b0a",
  null
  
)

export default component.exports